import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/logo.webp'
import _imports_1 from '@/assets/imgs/logo.png'
import _imports_2 from '@/assets/imgs/server.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-545b8015")

_pushScopeId("data-v-545b8015")
const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "pc-login-root" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("picture", { class: "logo" }, [
  /*#__PURE__*/_createVNode("source", {
    type: "image/webp",
    srcset: _hoisted_1
  }),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    "data-was-processed": "true",
    "data-src": "~@/assets/imgs/logo.png"
  })
], -1)
const _hoisted_6 = { class: "input uname" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "input pass" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "capcha-wrap" }
const _hoisted_11 = { class: "input" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "capcha" }
const _hoisted_14 = { class: "error" }
const _hoisted_15 = { class: "btns" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\" data-v-545b8015><div class=\"row\" data-v-545b8015><span data-v-545b8015>本公司领有菲律宾合法网上娱乐牌照（Interactive Gaming Licence）：046</span><span data-v-545b8015>环球360娱乐场版权所有</span></div><div class=\"row\" data-v-545b8015><div data-v-545b8015><span class=\"icon icon-call\" data-v-545b8015></span><span class=\"text\" data-v-545b8015>+855 85801111 </span></div><div data-v-545b8015></div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_language_box = _resolveComponent("language-box")

  return (_openBlock(), _createBlock("div", _hoisted_2, [
    _createVNode("div", {
      class: ["lang", _ctx.lang],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLangbox = true))
    }, _toDisplayString(_ctx.iN(`lang.${_ctx.lang}`)), 3),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.iN('login.username')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.uname = $event))
          }, null, 512), [
            [_vModelText, _ctx.uname]
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.iN('login.password')), 1),
          _withDirectives(_createVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pwd = $event))
          }, null, 512), [
            [_vModelText, _ctx.pwd]
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.iN('login.code')), 1),
            _withDirectives(_createVNode("input", {
              type: "number",
              maxlength: 4,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.cpth = $event)),
              onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkCapchaLenght && _ctx.checkCapchaLenght(...args)))
            }, null, 544), [
              [
                _vModelText,
                _ctx.cpth,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("img", { src: _ctx.imgSrc }, null, 8, ["src"])
          ]),
          _createVNode("div", {
            class: "icon icon-reload",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getImageSrc && _ctx.getImageSrc(...args)))
          })
        ]),
        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", {
            class: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.doLoginWithCaptcha && _ctx.doLoginWithCaptcha(...args)))
          }, _toDisplayString(_ctx.iN('login.login')), 1)
        ])
      ]),
      _createVNode("img", {
        src: _imports_2,
        class: "server",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.OnCLickedServer && _ctx.OnCLickedServer(...args)))
      })
    ]),
    _hoisted_16,
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLangbox)
          ? (_openBlock(), _createBlock(_component_language_box, {
              key: 0,
              class: "lang-box",
              onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showLangbox = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})